export default __webpack_public_path__ + "static/media/img_1.da1bdc9b.jpg";